import React from 'react'
import Select, { components } from 'react-select'
import styled from 'styled-components'
import { ExcelColorsLabels, ExcelColorsValues } from './colorDefinitions'

import { Flex } from '../../../../../common/styles/global_styles'

import {
    generateOptionsForExcelColorSelect, getExcelColorOptionForValue,
    onChangeColorOptionsSelect
} from './filesExcelBehavior'

export interface ExcelColorsOption {
    label: string
    value: ExcelColorsLabels
    color: ExcelColorsValues
}

interface Props {
    text: string
    value: ExcelColorsLabels
    name: string
    onChange: (field: string, value: ExcelColorsLabels) => void | any
}

const ColorOptionsSelect = ({ text = '', value = null, name = '', onChange }: Props) => {
    let options: ExcelColorsOption[] = generateOptionsForExcelColorSelect()
    return (
        <div key={'colorOptionsSelect_' + name} style={{ width: '100%' }}>
            <label style={{ fontWeight: 'bold' }}>{text}</label>
            <Select
                key={name}
                name={name}
                value={getExcelColorOptionForValue(value)}
                clearable={false}
                options={options}
                multi={false}
                components={{
                    ValueContainer: ValueSelected,
                    Option: OptionBox
                }}
                styles={{
                    singleValue: base => ({
                        ...base,
                        'font-weight': 'bold'
                    })
                }}
                onChange={newValue => onChangeColorOptionsSelect(name, newValue, onChange)}
            />
        </div>
    )
}

const ValueSelected = ({ children, ...props }) => {
    let value = props.getValue()
    let color = value[0] ? value[0].color : ''
    return (<RowSelectColor>
        <ColorRect color={color} />
        <label>{children}</label>
    </RowSelectColor>

    )
}

const OptionBox = ({ children, ...props }) => {
    const color = props.data?.color
    return (
        <components.Option {...props}>
            <RowSelectColor>
                <ColorRect color={color} />
                <label>{children}</label>
            </RowSelectColor>
        </components.Option>
    )
}

interface ColorRectProps {
    color?: string
    width?: string
}
const RowSelectColor = styled.div`
    height: 32px;
    display: flex;
    padding: 8px;
    label{
        padding-left: 4px;
        text-transform: capitalize;
    }

`
const ColorRect = styled.div<ColorRectProps>`
    border:black 1px solid;
    width: 16px;
    height: 16px;
    visibility: ${props => props.color ? "visible" : "hidden"};
    background-color: ${props => props.color};
`


export default ColorOptionsSelect